















import { MoveSlideMixin } from '@/components/mixins/move-slide';
import { SlideDirection } from '@/utils/slide-direction.enum';
import { VueCssClasses } from '@/utils/types';
import { VueConstructor } from 'vue';
import { Component, Mixins, Prop } from 'vue-property-decorator';

@Component
export default class NavigationButton extends Mixins(MoveSlideMixin) {
  @Prop({ required: true })
  slideDirection!: SlideDirection;

  @Prop({ required: true })
  slidingAnimationTimeInMs!: number;

  @Prop({ required: true })
  navigationButtonIcon!: VueConstructor;

  protected get dynamicCssClassesButton(): VueCssClasses {
    return [
      {
        'eco-navigation-button__left': this.slideDirection === SlideDirection.LEFT,
        'eco-navigation-button__right': this.slideDirection === SlideDirection.RIGHT
      }
    ];
  }

  protected get dynamicCssClassesIcon(): VueCssClasses {
    return [
      {
        'eco-navigation-left-button__arrow-icon left-arrow-icon':
          this.slideDirection === SlideDirection.LEFT,
        'eco-navigation-right-button__arrow-icon right-arrow-icon':
          this.slideDirection === SlideDirection.RIGHT
      }
    ];
  }
}
